import { useState } from "react";
import { Dialog } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";

import {
  FaTiktok,
  FaInstagram,
  FaSpotify,
  FaYoutube,
  FaTwitter,
  FaDiscord,
  FaLinkedin,
} from "react-icons/fa";

const navigation = [
  { id: 1, name: "Home" },
  { id: 2, name: "Projects" },
  { id: 3, name: "About Us" },
  { id: 4, name: "Contact" },
];

export default function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [menuSelection, setMenuSelection] = useState(1);

  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const people = [
    {
      name: "Thor Diogo Hagedorn",
      role: "Product & Technology",
      imageUrl: "/cara_foto.png",
      description: (
        <div>
          Thor Hagedorn is a musician, producer, curator, and creative technologist with over 20 years of experience across music production, live performance, and immersive formats. A passionate gamer and performer, he has appeared as a singer and dancer on international stages and continuously explores new ways of connecting music, culture, and technology.
          <br />
          <br />
          He has collaborated with <strong>Granola Studios</strong> and <strong>Warner Music</strong> to develop an artist showcase platform within Fortnite Creative Island, and is currently working with <strong>XR-Events</strong> on a hybrid concert format, contributing both as curator and performing artist. As bandleader and producer of the <strong>TDC Award–winning</strong> collective La Byle, Thor built strong expertise in social media strategy and content creation. He also serves as a mentor, curator, and board-of-trustees speaker at the <strong>Berlin Music Commission</strong>, where he actively advocates for diversity and social justice within the music industry.
          <br />
          <br />
          In 2024, he was awarded the <strong>LTB 24 Award</strong> in the category Innovative Concept in the Music Industry. For Thor, the metaverse is a powerful amplifier for artistic visions — a space where music, community, and imagination merge, enabling experiences that go beyond the limits of the physical world.
        </div>
      ),
    },
    {
      name: "Christine Seraphin",
      role: "Artistic & Social Catalyst",
      imageUrl: "/sera_foto.jpeg",
      description: (
        <div>
          <strong>Christine</strong> is a musician and performer working across jazz, pop, and electronic music, as well as theater and film, since 2009. She is a recipient of the <strong>German Jazz Prize (Deutscher Jazzpreis)</strong> in the category <strong>Vocal</strong>, recognizing her outstanding artistic contribution to contemporary jazz.
          <br /><br />
          Alongside her artistic practice, Christine holds a <strong>degree in Music Business and Cultural Relations</strong>, grounding her creative work in a strong understanding of cultural policy, creative economies, and international collaboration.
          <br /><br />
          Beyond the stage, she is a founder, community and event organizer, and mentor, working at the intersection of cultural empowerment and intersectional feminism. Her work focuses on building sustainable, inclusive spaces for women and marginalized creatives through music, art, community development, and event production.
          <br /><br />
          Christine’s mission is to create accessible platforms that enable exploration across disciplines—bridging art, technology, and virtual environments—while fostering collaboration, visibility, and long-term empowerment.
          <br /><br />
          <i>“Be the change you want to see.”</i>
        </div>
      ),
    },
    {
      name: "Arin",
      role: "Lead, Immersive Products & Cultural Technology",
      imageUrl: "/aryn_foto.png",
      description: (
        <div>
          Arin (Aryn) is the Founder and Creative Director of <strong>Metora</strong>, a Web3-native music IP platform enabling artists to own, perform, and monetize their work through immersive digital experiences. She brings over a decade of executional experience across advertising, large-scale music festivals, and platform-building in Southeast Asia.
          <br /><br />
          A <strong>British Council UK-ASEAN Creative Economy Programme</strong> alumna (2024–2025), Arin has led and delivered major regional projects, launched metaverse-native music experiences, and represented Malaysia at global industry platforms including <strong>SXSW Austin</strong> and <strong>Focus Wales</strong>. She is building Metora to unlock scalable, community-owned music economies across emerging markets.
        </div>
      ),
    }
    // More people...
  ];

  const posts = [
    {
      id: 1,
      title: "Workshops and Panels",
      href: "https://www.w3blab.io/",
      description:
        "These engaging sessions are designed to provide a platform for individuals to share their invaluable experiences and perspectives. Our workshops and panels specifically emphasize the significance of diversity and inclusivity, with a particular focus on areas such as VR Clubs and metaverse concerts. Through these initiatives, we strive to foster a better understanding and appreciation of the importance of embracing diversity and inclusivity in the rapidly evolving world of technology.",
      category: { title: "Event", color: "bg-blue-200" },
      imageUrl: "/projectB.jpg",
    },
    {
      id: 2,
      title: "Hypemersive",
      href: "https://www.clubbahnhofehrenfeld.de/events/4769/12-08-2022-xacaxaca-ft.-la-byle-live",
      description:
        "Berlin Hypemersive is a hybrid audiovisual club event that combines an in-real-life (IRL) location with a virtual reality rave to cross the boundaries between two worlds. Club goers* and DJs can be part of the event from anywhere in the world on a PC or immersively with VR glasses. At the same time, we bring the club as close as possible to cyberspace via large-scale projections. Visitors of both worlds are in sync and can interact with each other live.",
      category: { title: "Metaverse", color: "bg-pink-200" },
      imageUrl: "/projectA.jpeg",
    },
    {
      id: 3,
      title: "VIBE",
      href: "https://www.yabal.io/vibes",
      description: (
        <div>
          As the producers of these groundbreaking VIBE events, we take on the
          responsibility of curating and organizing e-concerts that redefine the
          boundaries of entertainment. Leveraging state-of-the-art technology,
          we create a truly immersive experience that transcends geographical
          limitations, allowing people from all corners of the world to
          participate. These e-concerts are hosted on the innovative Yabal
          platform, where a virtual island serves as the backdrop for an
          unforgettable 30-minute concert. We go the extra mile by inviting both
          international and local artists to perform, creating a rich and
          diverse lineup that caters to a wide range of musical tastes.
          Furthermore, our events provide a platform for artists and players to
          gain valuable knowledge about upcoming web3 technologies, keeping them
          at the forefront of digital innovation.
          <br />
          The VIBE online event can be easily accessed through the Yabal app,
          and we also offer an IRL (in real life) component where the VIBE event
          is open for physical visits.
        </div>
      ),
      category: { title: "Event", color: "bg-blue-200" },
      imageUrl: "/projectD.jpeg",
    },
    {
      id: 4,
      title: "La Byle",
      href: "https://labyle.netlify.app/",
      description: (
        <div>
          The sound of La By’le [ˈLa:baɪ̯liː] is a feverish percussive driven
          social statement. The umbanda rhythms cut up into electronic
          dancefloor disorientation stays true to its ritual practice.
          <br />
          La By’le’s spice confidently breaks through borders with a fun,
          humorous, and provocative vantage point.
          <br />
          Performing with a stage presence worthy of sacrifice and of audience
          reciprocation, this act demands direct interaction. The group
          celebrates its diversity by embracing their cultural differences
          merging into this funky reappropriation of groovy.
          <br />
          Demonstrating their fight against patriarchy through the grasping of
          sexual complexity, you are invited to shake every part of your body
          against the violence that constrains all of us. La Byle now also has
          their presence in the Metaverse as avatars, where they can be seen
          worldwide for the digital audience on the Yabal.io platform.
        </div>
      ),
      category: { title: "Music", color: "bg-green-200" },
      imageUrl: "/projectC.png",
    },
  ];

  return (
    <div className="bg-white">
      <header className="absolute inset-x-0 top-0 z-50">
        <nav
          className="flex items-center justify-between p-6 lg:px-8"
          aria-label="Global"
        >
          <div className="flex lg:flex-1 items-center">
            <a className="-m-1.5 p-1.5">
              <span className="sr-only">Diasporic</span>
              <img
                className="lg:h-20 h-10 w-auto"
                src="/diasporicaa_logo.png"
                alt=""
              />
            </a>
            <a className=" ml-5 text-lg font-semibold leading-6 text-gray-900">
              Diasporic Arts Alliance
            </a>
          </div>
          <div className="flex lg:hidden">
            <button
              type="button"
              className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
              onClick={() => setMobileMenuOpen(true)}
            >
              <span className="sr-only">Open main menu</span>
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="hidden lg:flex lg:gap-x-12">
            {navigation.map((item) => (
              <a
                key={item.name}
                onClick={() => {
                  setMenuSelection(item.id);
                }}
                className="text-sm font-semibold leading-6 text-gray-900"
              >
                {item.name}
              </a>
            ))}
          </div>
          <div className="hidden lg:flex lg:flex-1 lg:justify-end">
            <a className="-m-1.5 p-1.5">
              <span className="sr-only">Diasporic</span>
              <img
                className="h-20 w-auto"
                src="/berlinmusiccommission.png"
                alt=""
              />
            </a>
          </div>
        </nav>
        <Dialog
          as="div"
          className="lg:hidden"
          open={mobileMenuOpen}
          onClose={setMobileMenuOpen}
        >
          <div className="fixed inset-0 z-50" />
          <Dialog.Panel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
            <div className="flex items-center justify-between">
              <a className="-m-1.5 p-1.5">
                <span className="sr-only">Your Company</span>
                <img
                  className="h-8 w-auto"
                  src="/diasporicaa_logo.png"
                  alt=""
                />
              </a>
              <button
                type="button"
                className="-m-2.5 rounded-md p-2.5 text-gray-700"
                onClick={() => setMobileMenuOpen(false)}
              >
                <span className="sr-only">Close menu</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
            <div className="mt-6 flow-root">
              <div className="-my-6 divide-y divide-gray-500/10">
                <div className="space-y-2 py-6">
                  {navigation.map((item) => (
                    <a
                      key={item.name}
                      className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                      onClick={() => {
                        setMenuSelection(item.id);
                        setMobileMenuOpen(false);
                      }}
                    >
                      {item.name}
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </Dialog.Panel>
        </Dialog>
      </header>

      {/* Home */}
      {menuSelection == 1 && (
        <div className="-z-10">
          <div className="relative isolate px-6 pt-5 lg:px-8">
            {/*<div
              className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
              aria-hidden="true"
            >
              <div
                className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
                style={{
                  clipPath:
                    "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
                }}
              />
              </div>*/}
            <div className="mx-auto max-w-3xl py-32 sm:py-48 lg:py-56">
              <div className="hidden sm:mb-8 sm:flex sm:justify-center">
                <div
                  onClick={() => setMenuSelection(2)}
                  className="relative rounded-full px-3 py-1 text-sm leading-6 text-gray-600 ring-1 ring-gray-900/10 hover:ring-gray-900/20"
                >
                  Come as you are and start your journey!{" "}
                  <a className="font-semibold text-indigo-600">
                    <span className="absolute inset-0" aria-hidden="true" />
                    Check out our projects!
                    <span aria-hidden="true">&rarr;</span>
                  </a>
                </div>
              </div>
              <div className="text-center">
                <h1 className="lg:text-6xl text-5xl font-bold tracking-tight text-gray-900 sm:text-6xl pb-4">
                  Diasporic Arts Alliance
                </h1>
                <h1 className="lg:text-5xl text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
                  We establish one-of-a-kind events
                </h1>
                <p className="mt-6 text-lg leading-8 text-gray-600">
                  We are a group of visualists with experience in the curation
                  of flourishing communities and events. We aim to curate an
                  international virtual and in real life (IRL) gathering spot
                  where all walks of life can connect, break down barriers and
                  build bridges across culture and geography. Together we can
                  cultivate and explore a garden of possibilities that blossom
                  into new realities.
                </p>
                <div className="mt-10 flex items-center justify-center gap-x-6">
                  <a
                    onClick={() => setMenuSelection(2)}
                    className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  >
                    Get started
                  </a>
                  <a
                    onClick={() => setMenuSelection(3)}
                    className="text-sm font-semibold leading-6 text-gray-900"
                  >
                    About Us <span aria-hidden="true">→</span>
                  </a>
                </div>
              </div>
            </div>
            {/*<div
              className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]"
              aria-hidden="true"
            >
              <div
                className="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]"
                style={{
                  clipPath:
                    "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
                }}
              />
              </div>*/}
          </div>
        </div>
      )}

      {/* Projects */}
      {menuSelection == 2 && (
        <div className="bg-white py-24 sm:py-32">
          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="mx-auto max-w-2xl lg:mx-0">
              <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                Projects
              </h2>
              <p className="mt-2 text-lg leading-8 text-gray-600">
                From VR Concerts to everything you can imagine!
              </p>
            </div>
            <div className="mx-auto mt-10 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 border-t border-gray-200 pt-10 sm:mt-16 sm:pt-16 lg:mx-0 lg:max-w-none lg:grid-cols-3">
              {posts.map((post) => (
                <article
                  key={post.id}
                  className="flex max-w-xl flex-col items-start justify-start"
                >
                  <div className="flex items-center gap-x-4 text-xs">
                    {/*<time dateTime={post.datetime} className="text-gray-500">
                      {post.date}
              </time>*/}
                    <a
                      className={`relative z-10 rounded-full ${post.category.color} px-3 py-1.5 font-medium text-gray-600 hover:bg-gray-100`}
                    >
                      {post.category.title}
                    </a>
                  </div>

                  <img
                    className="my-4 w-100 rounded-xl border"
                    src={post.imageUrl}
                    alt=""
                    onClick={() =>
                      window.open(post.href, "_blank", "noopener,noreferrer")
                    }
                  />

                  <div className="group relative">
                    <h3 className="mt-3 text-lg font-semibold leading-6 text-gray-900 group-hover:text-gray-600">
                      <span className="absolute inset-0" />
                      <div>{post.title}</div>
                    </h3>
                    <div className="mt-5 text-sm leading-6 text-gray-600 text-justify">
                      {post.description}
                    </div>
                  </div>
                  {/*<div className="relative mt-8 flex items-center gap-x-4">
                    <img
                      src={post.author.imageUrl}
                      alt=""
                      className="h-10 w-10 rounded-full bg-gray-50"
                    />
                    <div className="text-sm leading-6">
                      <p className="font-semibold text-gray-900">
                        <a href={post.author.href}>
                          <span className="absolute inset-0" />
                          {post.author.name}
                        </a>
                      </p>
                      <p className="text-gray-600">{post.author.role}</p>
                    </div>
                    </div>*/}
                </article>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Team */}
      {menuSelection == 3 && (
        <div className="bg-white py-24 sm:py-32">
          <div className="mx-auto grid max-w-7xl gap-x-8 gap-y-20 px-6 lg:px-8 xl:grid-cols-3">
            <div className="max-w-2xl">
              <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                Meet our team
              </h2>
              <p className="mt-6 text-lg leading-8 text-gray-600">
                We are a group of visualists with experience in the curation of
                flourishing communities and events. We aim to curate an
                international virtual and in real life (IRL) gathering spot
                where all walks of life can connect, break down barriers and
                build bridges across culture and geography. Together we can
                cultivate and explore a garden of possibilities that blossom
                into new realities. Come as you are and start your journey!
              </p>
            </div>
            <ul
              role="list"
              className="grid gap-x-8 gap-y-12 sm:grid-cols-2 sm:gap-y-16 xl:col-span-2"
            >
              {people.map((person) => (
                <li key={person.name}>
                  <div>
                    <div className="flex items-center gap-x-6">
                      <img
                        className="h-100 w-40 rounded-xl"
                        src={person.imageUrl}
                        alt=""
                      />
                      <div>
                        <h3 className="text-base font-semibold leading-7 tracking-tight text-gray-900">
                          {person.name}
                        </h3>
                        <p className="text-sm font-semibold leading-6 text-indigo-600">
                          {person.role}
                        </p>
                      </div>
                    </div>
                    <div className="my-5 text-gray-600 text-sm text-justify">
                      {person.description}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}

      {/* Contact */}
      {menuSelection == 4 && (
        <div className="isolate bg-white px-6 py-24 sm:py-32 lg:px-8">
          <div
            className="absolute inset-x-0 top-[-10rem] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[-20rem]"
            aria-hidden="true"
          >
            <div
              className="relative left-1/2 -z-10 aspect-[1155/678] w-[36.125rem] max-w-none -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-40rem)] sm:w-[72.1875rem]"
              style={{
                clipPath:
                  "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
              }}
            />
          </div>
          <div className="mx-auto max-w-2xl text-center">
            <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
              Contact Us!
            </h2>
            <p className="mt-2 text-lg leading-8 text-gray-600">
              Let's create together!
            </p>
          </div>
          <form
            action="#"
            method="POST"
            className="mx-auto mt-8 max-w-xl sm:mt-20"
          >
            <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
              <div className="sm:col-span-2">
                <label
                  htmlFor="email"
                  className="block text-sm font-semibold leading-6 text-gray-900"
                >
                  Email
                </label>
                <div className="mt-2.5">
                  <input
                    type="email"
                    name="email"
                    id="email"
                    onChange={(val) => {
                      setEmail(val.target.value);
                    }}
                    autoComplete="email"
                    className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
                </div>
              </div>
              <div className="sm:col-span-2">
                <label
                  htmlFor="message"
                  className="block text-sm font-semibold leading-6 text-gray-900"
                >
                  Message
                </label>
                <div className="mt-2.5">
                  <textarea
                    name="message"
                    id="message"
                    onChange={(val) => {
                      setMessage(val.target.value);
                    }}
                    rows={4}
                    className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    defaultValue={""}
                  />
                </div>
              </div>
            </div>
            <div className="mt-10">
              <button
                type="submit"
                className="block w-full rounded-md bg-indigo-600 px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                <a
                  href={`mailto:diasporicartsalliance@gmail.com?subject=${email}&body=${message}`}
                >
                  Let's talk!
                </a>
              </button>
            </div>
          </form>
        </div>
      )}

      <footer className="z-100">
        <div className={"flex justify-center items-center gap-10 px-4 mb-10"}>
          <div
            onClick={() => {
              window.open(
                "https://www.instagram.com/diasporicartsalliance/",
                "_blank",
                "noopener,noreferrer"
              );
            }}
          >
            <FaInstagram className={"h-95% aspect-square"} />
          </div>
          <div
            onClick={() => {
              window.open(
                "https://twitter.com/diasporicAA",
                "_blank",
                "noopener,noreferrer"
              );
            }}
          >
            <FaTwitter className={"h-95% aspect-square"} />
          </div>
          <div
            onClick={() => {
              window.open(
                "https://www.linkedin.com/company/diasporic-arts-alliance",
                "_blank",
                "noopener,noreferrer"
              );
            }}
          >
            <FaLinkedin className={"h-95% aspect-square"}></FaLinkedin>
          </div>
        </div>
      </footer>
    </div>
  );
}
